import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxSpinnerModule } from 'ngx-spinner';

import { HomeModule } from '@core/home/home.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AlertModule } from './shared/alert/alert.module';

import { ApiService } from '@services/api-service';

import { JwtInterceptor } from './_helper/jwt.interceptor';

import {
    HashLocationStrategy,
    LocationStrategy,
    registerLocaleData,
} from '@angular/common';
import ptBr from '@angular/common/locales/pt';

import { LayoutModule } from '@shared/layout/layout.module';
import { DocumentModalModule } from '@shared/modals/document-modal/document-modal.module';
import { ToastrModule } from 'ngx-toastr';
import { RuntimeConfigLoaderModule } from 'runtime-config-loader';
import { VerificaAutenticidadeSharedModule } from '../../projects/verifica-autenticidade/src/app/app.module';
import { AuthModule } from './auth/auth.module';
import { VersionModalModule } from './shared/modals/version-modal/version-modal.module';

import { darkTheme } from '@core/theme/dark-theme';
import { genericTheme } from '@core/theme/generic-theme';
import { lccvTheme } from '@core/theme/lccv-theme';
import { ThemeModule } from '@core/theme/theme.module';
import { PagesModule } from '@views/pages/pages.module';
import { environment } from 'src/environments/environment';
import { ColaboradorService } from './modules/colaboradores/services/colaborador.service';

registerLocaleData(ptBr, 'pt-BR');

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-center',
            preventDuplicates: true,
            maxOpened: 2,
            progressBar: true,
            timeOut: 3000,
            closeButton: true,
        }),
        AppRoutingModule,
        BsDropdownModule.forRoot(),
        AlertModule,
        VersionModalModule,
        HomeModule,
        PagesModule,
        LayoutModule,
        DocumentModalModule,
        AuthModule,
        NgbModule,
        FormsModule,
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxSpinnerModule,
        VerificaAutenticidadeSharedModule.forRoot(),
        RuntimeConfigLoaderModule.forRoot({
            configUrl: 'api/config-front',
        }),
        ThemeModule.forRoot({
            themes: [lccvTheme, genericTheme, darkTheme],
            active: environment.theme,
        }),
    ],
    providers: [
        ApiService,
        ColaboradorService,
        Title,

        {
            provide: LOCALE_ID,
            useValue: 'pt-BR',
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true,
        },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
